import { Injectable } from '@angular/core';
import {Headers, Http, RequestOptions} from '@angular/http';
import {ConnectionService} from "./connection.service";
import {Observable} from "rxjs/Observable";
import {Job} from "../entities/Job";
import {AppConfig} from "../app.config";
import {RequestInterceptor} from "./Interceptors/RequestInterceptor";

@Injectable()
export class JobService {

  private readonly apiUrl: string;

  private getHeaders(company = null): RequestOptions {
    const headers: Headers = this.connectionService.GetAuthorizationHeader(company);
    return new RequestOptions({ headers });
  }

  constructor(private http: Http,
              private connectionService: ConnectionService,
              private config : AppConfig,
              private requestInterceptor: RequestInterceptor) {
    this.apiUrl = config.getConfig('endPointApiUrl');
  }

  public GetJobs() : Observable<Job[]>
  {
    let url = this.apiUrl + 'api/Jobs/GetJobs/';

    return this.requestInterceptor
    .get(url, this.getHeaders())
    .map(response => response.json() as Job[]);
  }

  public GetJobsForResponsible(salesPersonCode : string) : Observable<Job[]>
  {
    let url = this.apiUrl + 'api/Jobs/GetJobsForResponsible/' + salesPersonCode;

    return this.requestInterceptor
      .get(url, this.getHeaders())
      .map(response => response.json() as Job[]);
  }

  public GetJob(jobNo : string) : Observable<Job>
  {
    let url = this.apiUrl + 'api/Jobs/' + btoa(jobNo);

    return this.requestInterceptor
      .get(url, this.getHeaders())
      .map(response => response.json() as Job);
  }

  public PutJob(job : Job) : Observable<Job>
  {
    let url = this.apiUrl + 'api/Jobs/UpdateTime/';

    return this.http
      .put(url, JSON.stringify(job), this.getHeaders())
      .map(response => response.json() as Job);
  }

}





// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/job.service.ts